import React from 'react'
import ReactDOM from 'react-dom'
import { StateInspector } from 'reinspect'
import DelayedMountContainer from '@components/DelayedMountContainer'
import PropertiesPage from './PropertiesPage'
import PropertyPage from './PropertyPage'
import { StoreProvider } from './Store'
import { Router, RouteComponentProps } from '@reach/router'

ReactDOM.render(
  <StateInspector name="Properties App">
    <StoreProvider>
      <DelayedMountContainer>
        <Router>
          <PropertiesPage path="/properties" />
          <PropertyPage path="/properties/:propertyId" />
        </Router>
      </DelayedMountContainer>
    </StoreProvider>
  </StateInspector>,
  document.getElementById('properties')
)
